import { render } from "./AddContact.vue?vue&type=template&id=247d9b1c&scoped=true"
import script from "./AddContact.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddContact.vue?vue&type=script&charset=utf-8&lang=js"

import "./AddContact.vue?vue&type=style&index=0&id=247d9b1c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247d9b1c"]])

export default __exports__